const Title = () => {
    return(
        <div>
            <h1>React World Weather</h1>
        </div>
    )
}

export default Title;